import "./ServersTypeBlock.scss";
import {useHistory, useLocation} from "react-router-dom";
import {useEffect} from "react";
import {useI18n} from "../../../../i18n/I18nProvider";

const ServersTypeBlock = ({setType}) => {
    const { t } = useI18n();

    const history = useHistory();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const type = searchParams.get("s") === "trio" ? "trio" : "lite";

    useEffect(() => {
        setType(type)
    }, [type])

    const handleClick = (newType: "lite" | "trio") => {
        searchParams.set("s", newType);
        history.replace({ pathname: location.pathname, search: searchParams.toString() });
    };

    return (
        <div className="srv-picker">
            <h3 className="srv-picker-title">{t("servers.title")}</h3>
            <p className="srv-picker-text" dangerouslySetInnerHTML={{ __html: t("servers.text") }} />
            <div className={`srv-seg ${type === "trio" ? "srv-seg-trio" : ""}`}>
                <span className="srv-seg-thumb" />
                <button type="button" className={`srv-seg-btn ${type === "lite" ? "active" : ""}`} onClick={() => handleClick("lite")}>
                    LITE
                </button>
                <button type="button" className={`srv-seg-btn ${type === "trio" ? "active" : ""}`} onClick={() => handleClick("trio")}>
                    TRIO
                </button>
            </div>
        </div>
    );
};

export default ServersTypeBlock;
